var map = {
	"./": [
		8109
	],
	"./Booklet/Cover1": [
		4029
	],
	"./Booklet/Cover1.ts": [
		4029
	],
	"./Booklet/Cover2": [
		2624
	],
	"./Booklet/Cover2.ts": [
		2624
	],
	"./Booklet/Cover3": [
		6631
	],
	"./Booklet/Cover3.ts": [
		6631
	],
	"./Booklet/Cover4": [
		1006
	],
	"./Booklet/Cover4.ts": [
		1006
	],
	"./Booklet/Image1": [
		1927
	],
	"./Booklet/Image1.ts": [
		1927
	],
	"./Booklet/Image2": [
		1624
	],
	"./Booklet/Image2.ts": [
		1624
	],
	"./Booklet/Image3": [
		7046
	],
	"./Booklet/Image3.ts": [
		7046
	],
	"./Booklet/Mixed1": [
		3291
	],
	"./Booklet/Mixed1.ts": [
		3291
	],
	"./Booklet/Mixed2": [
		4434
	],
	"./Booklet/Mixed2.ts": [
		4434
	],
	"./Booklet/Quote1": [
		6974
	],
	"./Booklet/Quote1.ts": [
		6974
	],
	"./Booklet/Quote2": [
		6385
	],
	"./Booklet/Quote2.ts": [
		6385
	],
	"./Booklet/Quote3": [
		6086
	],
	"./Booklet/Quote3.ts": [
		6086
	],
	"./Booklet/SimpleLayout": [
		826,
		826
	],
	"./Booklet/SimpleLayout.ts": [
		826,
		826
	],
	"./Booklet/Text1": [
		843
	],
	"./Booklet/Text1.ts": [
		843
	],
	"./Booklet/Text2": [
		1921
	],
	"./Booklet/Text2.ts": [
		1921
	],
	"./Examples/Example1/variant1": [
		1249,
		249
	],
	"./Examples/Example1/variant1.ts": [
		1249,
		249
	],
	"./Examples/Example1/variant2": [
		5751,
		751
	],
	"./Examples/Example1/variant2.ts": [
		5751,
		751
	],
	"./Examples/Example1/variant3": [
		5004,
		4
	],
	"./Examples/Example1/variant3.ts": [
		5004,
		4
	],
	"./Examples/Example1/variant4": [
		2099,
		99
	],
	"./Examples/Example1/variant4.ts": [
		2099,
		99
	],
	"./Examples/Example2/variant1": [
		9792,
		792
	],
	"./Examples/Example2/variant1.ts": [
		9792,
		792
	],
	"./Examples/Example2/variant2": [
		2884,
		884
	],
	"./Examples/Example2/variant2.ts": [
		2884,
		884
	],
	"./Examples/Example2/variant3": [
		3286,
		286
	],
	"./Examples/Example2/variant3.ts": [
		3286,
		286
	],
	"./Examples/Example2/variant4": [
		2881,
		881
	],
	"./Examples/Example2/variant4.ts": [
		2881,
		881
	],
	"./Examples/Example3/variant1": [
		5600,
		600
	],
	"./Examples/Example3/variant1.ts": [
		5600,
		600
	],
	"./Examples/Example3/variant2": [
		6554,
		554
	],
	"./Examples/Example3/variant2.ts": [
		6554,
		554
	],
	"./Examples/Example3/variant3": [
		4619,
		619
	],
	"./Examples/Example3/variant3.ts": [
		4619,
		619
	],
	"./Examples/Example3/variant4": [
		8932,
		932
	],
	"./Examples/Example3/variant4.ts": [
		8932,
		932
	],
	"./Examples/Example4/variant1": [
		8053,
		53
	],
	"./Examples/Example4/variant1.ts": [
		8053,
		53
	],
	"./Examples/Example4/variant2": [
		8802,
		802
	],
	"./Examples/Example4/variant2.ts": [
		8802,
		802
	],
	"./Examples/Example4/variant3": [
		7957,
		957
	],
	"./Examples/Example4/variant3.ts": [
		7957,
		957
	],
	"./Examples/Example4/variant4": [
		7112,
		112
	],
	"./Examples/Example4/variant4.ts": [
		7112,
		112
	],
	"./Examples/Example5/variant1": [
		8842,
		842
	],
	"./Examples/Example5/variant1.ts": [
		8842,
		842
	],
	"./Examples/Example5/variant2": [
		3048,
		48
	],
	"./Examples/Example5/variant2.ts": [
		3048,
		48
	],
	"./Examples/Example5/variant3": [
		5850,
		850
	],
	"./Examples/Example5/variant3.ts": [
		5850,
		850
	],
	"./Examples/Example5/variant4": [
		100,
		100
	],
	"./Examples/Example5/variant4.ts": [
		100,
		100
	],
	"./Examples/Example6/variant1": [
		6067,
		67
	],
	"./Examples/Example6/variant1.ts": [
		6067,
		67
	],
	"./Examples/Example6/variant2": [
		2925,
		925
	],
	"./Examples/Example6/variant2.ts": [
		2925,
		925
	],
	"./Examples/Example6/variant3": [
		2149,
		149
	],
	"./Examples/Example6/variant3.ts": [
		2149,
		149
	],
	"./Examples/Example6/variant4": [
		7232,
		232
	],
	"./Examples/Example6/variant4.ts": [
		7232,
		232
	],
	"./Presentation/Cover1": [
		1718
	],
	"./Presentation/Cover1.ts": [
		1718
	],
	"./Presentation/Cover2": [
		8385
	],
	"./Presentation/Cover2.ts": [
		8385
	],
	"./Presentation/Cover3": [
		5076
	],
	"./Presentation/Cover3.ts": [
		5076
	],
	"./Presentation/Image1": [
		8952
	],
	"./Presentation/Image1.ts": [
		8952
	],
	"./Presentation/Image2": [
		7411
	],
	"./Presentation/Image2.ts": [
		7411
	],
	"./Presentation/Mixed1": [
		4346
	],
	"./Presentation/Mixed1.ts": [
		4346
	],
	"./Presentation/Mixed2": [
		1563
	],
	"./Presentation/Mixed2.ts": [
		1563
	],
	"./Presentation/Quote1": [
		9022
	],
	"./Presentation/Quote1.ts": [
		9022
	],
	"./Presentation/Quote2": [
		2402
	],
	"./Presentation/Quote2.ts": [
		2402
	],
	"./Presentation/Text1": [
		4283
	],
	"./Presentation/Text1.ts": [
		4283
	],
	"./Presentation/Text2": [
		5813
	],
	"./Presentation/Text2.ts": [
		5813
	],
	"./Presentation/Text3": [
		8409
	],
	"./Presentation/Text3.ts": [
		8409
	],
	"./Presentation/Text4": [
		7669
	],
	"./Presentation/Text4.ts": [
		7669
	],
	"./Sheet/2Text2Image": [
		3739
	],
	"./Sheet/2Text2Image.ts": [
		3739
	],
	"./Sheet/3Image": [
		1637
	],
	"./Sheet/3Image.ts": [
		1637
	],
	"./Sheet/Image3Text": [
		1571
	],
	"./Sheet/Image3Text.ts": [
		1571
	],
	"./Sheet/ImageQuote": [
		8951
	],
	"./Sheet/ImageQuote.ts": [
		8951
	],
	"./Sheet/ImageText": [
		506
	],
	"./Sheet/ImageText.ts": [
		506
	],
	"./Sheet/Quote2Image": [
		2823
	],
	"./Sheet/Quote2Image.ts": [
		2823
	],
	"./Sheet/Quote4Image": [
		3997
	],
	"./Sheet/Quote4Image.ts": [
		3997
	],
	"./Sheet/Text": [
		2889
	],
	"./Sheet/Text.ts": [
		2889
	],
	"./Sheet/Text2Image": [
		1924
	],
	"./Sheet/Text2Image.ts": [
		1924
	],
	"./Sheet/Text4Image": [
		7777
	],
	"./Sheet/Text4Image.ts": [
		7777
	],
	"./Sheet/Title2Paragraph": [
		1796
	],
	"./Sheet/Title2Paragraph.ts": [
		1796
	],
	"./Sheet/TitleImageQuote": [
		11
	],
	"./Sheet/TitleImageQuote.ts": [
		11
	],
	"./Sheet/TitleParagraph": [
		5926
	],
	"./Sheet/TitleParagraph.ts": [
		5926
	],
	"./Story/2Body2Images": [
		6163
	],
	"./Story/2Body2Images.ts": [
		6163
	],
	"./Story/Body": [
		9624
	],
	"./Story/Body.ts": [
		9624
	],
	"./Story/CaptionHeadlineBody": [
		1990
	],
	"./Story/CaptionHeadlineBody.ts": [
		1990
	],
	"./Story/Headline2Images": [
		5882
	],
	"./Story/Headline2Images.ts": [
		5882
	],
	"./Story/Headline4Images": [
		9100
	],
	"./Story/Headline4Images.ts": [
		9100
	],
	"./Story/HeadlineImage1": [
		2000
	],
	"./Story/HeadlineImage1.ts": [
		2000
	],
	"./Story/HeadlineImage2": [
		5885
	],
	"./Story/HeadlineImage2.ts": [
		5885
	],
	"./Story/HeadlineImage3": [
		1510
	],
	"./Story/HeadlineImage3.ts": [
		1510
	],
	"./Story/ImageCaptionHeadline": [
		9906
	],
	"./Story/ImageCaptionHeadline.ts": [
		9906
	],
	"./Story/ImageHeadlineBody": [
		3467
	],
	"./Story/ImageHeadlineBody.ts": [
		3467
	],
	"./Story/Quote": [
		4915
	],
	"./Story/Quote.ts": [
		4915
	],
	"./Story/QuoteCaption": [
		7855
	],
	"./Story/QuoteCaption.ts": [
		7855
	],
	"./Story/Sequence": [
		8060,
		60
	],
	"./Story/Sequence.ts": [
		8060,
		60
	],
	"./index": [
		8109
	],
	"./index.ts": [
		8109
	],
	"./types": [
		4323,
		323
	],
	"./types.ts": [
		4323,
		323
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6247;
module.exports = webpackAsyncContext;